import {
  LayoutDashboard,
  FolderKanban,
  Package,
  StickyNote,
  Users,
  ScrollText,
  LogOut,
  type LucideIcon,
} from "lucide-react";
import {
  Sidebar as LibSidebar,
  type SidebarNavGroup,
} from "@marekl/adminer/shell";
import type { User, Role } from "../../auth/queries";

interface DemoNavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
}

interface DemoNavGroup {
  label: string;
  requiredRoles: Role[];
  items: DemoNavItem[];
}

const NAV_GROUPS: DemoNavGroup[] = [
  {
    label: "Přehled",
    requiredRoles: ["user", "manager", "superadmin"],
    items: [
      { to: "/dashboard", label: "Přehled", icon: LayoutDashboard, end: true },
    ],
  },
  {
    label: "Data",
    requiredRoles: ["user", "manager", "superadmin"],
    items: [
      { to: "/categories", label: "Kategorie", icon: FolderKanban },
      { to: "/items", label: "Položky", icon: Package },
      { to: "/notes", label: "Poznámky", icon: StickyNote },
    ],
  },
  {
    label: "Správa",
    requiredRoles: ["manager", "superadmin"],
    items: [{ to: "/audit-log", label: "Audit log", icon: ScrollText }],
  },
  {
    label: "Superadmin",
    requiredRoles: ["superadmin"],
    items: [{ to: "/users", label: "Uživatelé", icon: Users }],
  },
];

const ROLE_LABEL: Record<Role, string> = {
  user: "Uživatel",
  manager: "Správce",
  superadmin: "Superadmin",
};

interface SidebarProps {
  user: User;
  onLogout: () => void;
}

export function Sidebar({ user, onLogout }: SidebarProps) {
  const groups: SidebarNavGroup[] = NAV_GROUPS.filter((g) =>
    g.requiredRoles.includes(user.role),
  ).map((g) => ({
    label: g.label,
    items: g.items.map(({ to, label, icon: Icon, end }) => ({
      to,
      label,
      end,
      icon: <Icon aria-hidden="true" />,
    })),
  }));

  return (
    <LibSidebar
      groups={groups}
      user={{
        displayName: user.display_name || user.username,
        roleLabel: ROLE_LABEL[user.role],
      }}
      profileHref="/profile"
      onLogout={onLogout}
      logoutIcon={<LogOut aria-hidden="true" />}
    />
  );
}
